import {
  useOrganisation,
  useOrganisationList,
} from "@inrange/building-manager-api-client";
import {
  KindeUser,
  Organisation,
} from "@inrange/building-manager-api-client/models-organisation";
import { useState } from "react";
import { Button, Form, InputGroup, Table } from "react-bootstrap";
import { Link } from "react-router-dom";

const OrgUsers = ({ organisation }: { organisation: Organisation }) => {
  const { addOrgUser, removeOrgUser } = useOrganisation(organisation.id);
  const { fetchOrganisations } = useOrganisationList();
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [usersIsRemoving, setUsersIsRemoving] = useState<{
    [key: string]: boolean;
  }>({});

  const onAddUser = (user: KindeUser) => {
    addOrgUser.mutate(
      { ...user },
      {
        onError: (error: any) => {
          alert(error?.response?.data?.message || error);
        },
        onSuccess: () => {
          setUsersIsRemoving({ ...usersIsRemoving, [email]: false });
        },
      }
    );
  };

  const onRemoveUser = (email: string) => {
    setUsersIsRemoving({ ...usersIsRemoving, [email]: true });
    removeOrgUser.mutate(
      { email },
      {
        onError: (error: any) => {
          setUsersIsRemoving({ ...usersIsRemoving, [email]: false });
          alert(error?.response?.data?.message || error);
        },
      }
    );
  };

  const orgsById = (fetchOrganisations.data?.organisations || []).reduce(
    (
      acc: { [key: string]: { id: string; name: string } },
      org: { id: string; name: string }
    ) => {
      acc[org.id] = org;
      return acc;
    },
    {}
  );

  const testMode = !import.meta.env.PROD && import.meta.env.VITE_TEST_MODE;

  return (
    <div>
      <h4>Manage users ({organisation.users.length})</h4>
      {organisation.users.length > 0 && (
        <>
          <Table bordered responsive style={{ fontSize: 14 }}>
            <thead>
              <tr>
                <th>Email</th>
                <th>Name</th>
                <th>Shared by</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {organisation.users.map((user) => (
                <tr key={user.email}>
                  <td>{user.email}</td>
                  <td>
                    {user.firstName && user.lastName
                      ? `${user.firstName} ${user.lastName}`
                      : "(unknown)"}
                  </td>
                  <td>
                    {(
                      organisation?.userEmailPermissions?.[user.email]
                        ?.sharedByOrgs || []
                    ).map((sharedByOrgDetails, index) => (
                      <>
                        <Link
                          to={`/organisation/${sharedByOrgDetails.orgId}/edit`}
                          key={sharedByOrgDetails.orgId}
                          data-testid={`shared-by-org-${sharedByOrgDetails.orgId}`}
                        >
                          {orgsById[sharedByOrgDetails.orgId]
                            ? testMode
                              ? orgsById[sharedByOrgDetails.orgId].name.replace(
                                  /-.*/,
                                  " - fixed-id-for-testing"
                                )
                              : orgsById[sharedByOrgDetails.orgId].name
                            : "Loading name ..."}
                        </Link>
                        {index < sharedByOrgDetails.length - 1 ? ", " : ""}
                      </>
                    ))}
                  </td>
                  <td>
                    <Button
                      variant="primary"
                      onClick={() => onRemoveUser(user.email)}
                      disabled={usersIsRemoving[user.email]}
                    >
                      Remove user
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}

      <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
        <Form.Control
          placeholder="First name"
          type="text"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
        <Form.Control
          placeholder="Last name"
          type="text"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
        <InputGroup>
          <Form.Control
            placeholder="Email address"
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button
            variant="primary"
            onClick={() => {
              onAddUser({ email, firstName, lastName });
              setFirstName("");
              setLastName("");
              setEmail("");
            }}
            style={{ marginRight: 10 }}
          >
            Add user
          </Button>
        </InputGroup>
      </div>
    </div>
  );
};

export default OrgUsers;
